import { render, staticRenderFns } from "./sortGoods copy.vue?vue&type=template&id=7de62ab2&scoped=true&"
import script from "./sortGoods copy.vue?vue&type=script&lang=js&"
export * from "./sortGoods copy.vue?vue&type=script&lang=js&"
import style0 from "./sortGoods copy.vue?vue&type=style&index=0&id=7de62ab2&prod&langs=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de62ab2",
  null
  
)

export default component.exports